import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav a").eq(0).addClass("active")
var swiper = new Swiper(" .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        768: {  //当屏幕宽度大于等于1280
            slidesPerView: 2,
            spaceBetween: 20,
        }
    }
});